import { RadioBullet } from 'components/RadioGroup/RadioBullet'
import Styles from './BlogPostWizard.module.scss'
import { LineSkeleton } from 'components/Skeleton/LineSkeleton'

const TitleOptionStub = ({ position }: { position: number }) => (
  <div className={Styles.titleOptionStub}>
    <div />
    <div className={Styles.inputLabel}>Title #{position}</div>
    <RadioBullet size={20} isDisabled />
    <div className={Styles.titleOptionStubInput}>
      <LineSkeleton className={Styles.titleOptionStubShimmer} />
    </div>
  </div>
)

export const TitlesLoadingState = () => (
  <div className={Styles.titleOptionStubs}>
    <TitleOptionStub position={1} />
    <TitleOptionStub position={2} />
    <TitleOptionStub position={3} />
    <TitleOptionStub position={4} />
    <TitleOptionStub position={5} />
  </div>
)
